import React, { useState } from 'react';
import { ThumbsUp, ThumbsDown, MonitorX, Smartphone, AlertTriangle } from 'lucide-react';

// Lecteur YouTube intégré (responsive, sans autoplay son) + retours utilisateur.
export const YouTubePlayer = ({ video, onFeedback, primary = false }) => {
  const [given, setGiven] = useState(null);

  const handle = (type) => {
    if (given) return;
    setGiven(type);
    onFeedback && onFeedback(type, video.video_id);
  };

  const fmtDuration = (s) => {
    if (!s) return null;
    const m = Math.floor(s / 60);
    const sec = s % 60;
    return `${m}:${sec.toString().padStart(2, '0')}`;
  };

  const feedbacks = [
    { type: 'video_resolved', label: 'Résolu', icon: <ThumbsUp className="h-3.5 w-3.5" />, color: '#00FF88' },
    { type: 'video_not_relevant', label: 'Persiste', icon: <ThumbsDown className="h-3.5 w-3.5" />, color: '#FFB800' },
    { type: 'video_wrong_device', label: 'Mauvais appareil', icon: <MonitorX className="h-3.5 w-3.5" />, color: '#B8B8BA' },
    { type: 'video_wrong_app', label: 'Mauvaise appli', icon: <Smartphone className="h-3.5 w-3.5" />, color: '#B8B8BA' },
    { type: 'video_unavailable', label: 'Indisponible', icon: <AlertTriangle className="h-3.5 w-3.5" />, color: '#FF3B5C' },
  ];

  return (
    <div
      className={`rounded-xl overflow-hidden border ${primary ? 'border-[#FF6B35]/40' : 'border-[#3A3A3D]'} bg-[#0A0A0B]`}
      data-testid={`yt-player-${video.video_id}`}
    >
      <div className="relative w-full" style={{ paddingTop: '56.25%' }}>
        <iframe
          className="absolute inset-0 w-full h-full"
          src={`https://www.youtube.com/embed/${video.video_id}?rel=0&modestbranding=1`}
          title={video.title || 'Tutoriel vidéo'}
          frameBorder="0"
          allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          loading="lazy"
        />
      </div>
      <div className="p-3">
        {primary && (
          <span className="inline-block text-[10px] font-bold uppercase tracking-wide text-black bg-[#FF6B35] px-2 py-0.5 rounded-full mb-2">
            Vidéo recommandée
          </span>
        )}
        <p className="text-white text-sm font-semibold line-clamp-2">{video.title}</p>
        <div className="flex items-center gap-2 text-[#6B6B6E] text-xs mt-1">
          {video.channel_title && <span>{video.channel_title}</span>}
          {fmtDuration(video.duration_seconds) && <span>• {fmtDuration(video.duration_seconds)}</span>}
        </div>
        {video.summary && <p className="text-[#B8B8BA] text-xs mt-2">{video.summary}</p>}

        {given ? (
          <p className="text-[#00FF88] text-xs mt-3">Merci pour votre retour !</p>
        ) : (
          <div className="flex flex-wrap gap-1.5 mt-3">
            {feedbacks.map((f) => (
              <button
                key={f.type}
                onClick={() => handle(f.type)}
                className="flex items-center gap-1 text-xs px-2 py-1 rounded-md border border-[#3A3A3D] hover:border-current transition-colors"
                style={{ color: f.color }}
                data-testid={`yt-feedback-${f.type}-${video.video_id}`}
              >
                {f.icon}
                {f.label}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default YouTubePlayer;
